import Provider from './FeatureFlagsProvider';

export default Provider;
